import axios from "axios";
import { getAuth } from "firebase/auth";

const API_BASE_URL = "https://europe-west3-hyper-e122e.cloudfunctions.net";
const CREATE_CHAT_REQUEST_URL = "https://europe-west3-hyper-e122e.cloudfunctions.net/create_chat_request";

const ConsultantService = {

async updateConsultantStatus(isConsultant, totalConsultantExp) {

  if (typeof isConsultant !== "boolean") {
    throw new Error("isConsultant должен быть boolean");
  }
  const expNum = Number(totalConsultantExp);
  if (!Number.isFinite(expNum) || expNum < 0) {
    throw new Error("totalConsultantExp должен быть неотрицательным числом");
  }

  const auth = getAuth();
  const user = auth.currentUser;
  if (!user) throw new Error("❌ Пользователь не авторизован");

  const token = await user.getIdToken(true);

  try {
    const { data } = await axios.post(
      `${API_BASE_URL}/update_profile`,
      {
        updates: {
          is_consultant: isConsultant,
          total_consultant_exp: expNum,
        },
      },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        timeout: 15000,
      }
    );

    return data;
  } catch (err) {
    const msg =
      err?.response?.data?.message ||
      err?.response?.data?.error ||
      err.message ||
      "Неизвестная ошибка";
    console.error("❌ Ошибка при обновлении данных консультанта:", {
      status: err?.response?.status,
      data: err?.response?.data,
      msg,
    });
    const e = new Error(String(msg));
    e.status = err?.response?.status;
    e.data = err?.response?.data;
    throw e;
  }
}
,

    async createChatRequest({ consultantId, message }) {
    try {
      console.log("📨 [createChatRequest] Отправка запроса консультанту...");

      const auth = getAuth();
      const currentUser = auth.currentUser;
      if (!currentUser) throw new Error("❌ Пользователь не авторизован");

      const token = await currentUser.getIdToken(true);
      if (!token) throw new Error("❌ Не удалось получить токен");

      const payload = {
        requesterID: currentUser.uid,
        defendantID: consultantId,
        comment: message,
      };

      console.log("📦 Payload:", payload);

      const response = await axios.post(CREATE_CHAT_REQUEST_URL, payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      console.log("✅ Запрос успешно создан:", response.data);
      return response.data;

    } catch (error) {
      console.error("❌ Ошибка при создании запроса консультанту:");
      console.error("➡️", error.response?.data || error.message);
      throw error;
    }
  }
};

export default ConsultantService;